import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProfileProvider } from './context/ProfileContext';
import { DeviceCoursesProvider } from './context/DeviceCoursesContext';
import { AuthProvider } from './auth/AuthProvider';
import { AuthTokenBridge } from './auth/AuthTokenBridge';

const devStaticWebAppHost = 'thankful-desert-08f11701e.1.azurestaticapps.net';
const staticWebAppHosts = [
  'victorious-sea-080c6fa1e.7.azurestaticapps.net',
  'victorious-grass-036c8ae1e.2.azurestaticapps.net',
  devStaticWebAppHost,
];
const canonicalOrigin = window.location.hostname === devStaticWebAppHost
  ? 'https://clubhousedev.caddiesight.com'
  : 'https://clubhouse.caddiesight.com';

if (process.env.NODE_ENV === 'production' && staticWebAppHosts.includes(window.location.hostname)) {
  window.location.replace(`${canonicalOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`);
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <AuthTokenBridge />
        <ProfileProvider>
          <DeviceCoursesProvider>
            <App />
          </DeviceCoursesProvider>
        </ProfileProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/service-worker.js');
  });
}
